<template>
<loader v-bind="{ loading }">
  <div class="tabs">
    <ul>
      <router-link exact tag="li" :to="{ name: 'attribute-type-manager', params: { attributeType: $route.params.attributeType }}">
        <a>Overview</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'attribute-type-scrapers', params: { attributeType: $route.params.attributeType }}">
        <a>Scrapers</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'attribute-type-assessors', params: { attributeType: $route.params.attributeType }}">
        <a>Assessors</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'attribute-type-edit', params: { attributeType: $route.params.attributeType }}">
        <a>Edit</a>
      </router-link>
    </ul>
  </div>
  <router-view />
</loader>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    loading: true
  }),

  beforeCreate() {
    Promise.all([
       this.$store.dispatch('attributeType/loadAttributeType', this.$route.params.attributeType)
    ]).then(() => {
      this.loading = false
    })
  },

  computed: {
    ...mapGetters('attributeType', [
      'attributeType'
    ])
  }
}
</script>